import { render, staticRenderFns } from "./resume-payment-etc.vue?vue&type=template&id=19187df0&"
import script from "./resume-payment-etc.vue?vue&type=script&lang=js&"
export * from "./resume-payment-etc.vue?vue&type=script&lang=js&"
import style0 from "./resume-payment-etc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports